import { Language } from "@/modules/language/utils/languageUtils"
import dayjs, { type Dayjs } from "dayjs"

export type KPIPeriodModel = {
  focusYear: number
  focusMonth: number
  comparisonYear: number
  comparisonMonth: number
  periodLabel: string
}

export function createKPIPeriodModel(focusMonth: Dayjs, comparisonMonth: Dayjs, locale: Language): KPIPeriodModel {
  const comparisonLabel = comparisonMonth.locale(locale).format("MMM YYYY")
  const focusLabel = focusMonth.locale(locale).format("MMM YYYY")

  return {
    focusYear: focusMonth.year(),
    focusMonth: focusMonth.month(),
    comparisonYear: comparisonMonth.year(),
    comparisonMonth: comparisonMonth.month(),
    periodLabel: `${comparisonLabel} - ${focusLabel}`,
  }
}

export function getDefaultKPIPeriod(): { baseline: Dayjs; comparison: Dayjs } {
  const now = dayjs()
  return {
    baseline: now.startOf("month"),
    comparison: now.subtract(1, "month").startOf("month"),
  }
}

export function isMonthDisabledForComparison(month: Dayjs, focusMonth: Dayjs, boxCreationDate: Dayjs | null): boolean {
  const now = dayjs()
  const isCurrentMonth = month.isSame(now, "month")
  const isSameAsFocus = month.isSame(focusMonth, "month")
  const isAfterCurrentMonth = month.isAfter(now, "month")
  const isBeforeBoxCreation = boxCreationDate ? month.isBefore(boxCreationDate, "month") : false

  return isCurrentMonth || isSameAsFocus || isAfterCurrentMonth || isBeforeBoxCreation
}

export function isMonthDisabledForFocus(month: Dayjs, boxCreationDate: Dayjs | null): boolean {
  const now = dayjs()
  const isAfterCurrentMonth = month.isAfter(now, "month")
  const isBeforeBoxCreation = boxCreationDate ? month.isBefore(boxCreationDate, "month") : false

  return isAfterCurrentMonth || isBeforeBoxCreation
}

export function adjustComparisonMonthAfterFocusChange(
  newFocusMonth: Dayjs,
  currentComparisonMonth: Dayjs,
  boxCreationDate: Dayjs | null,
): Dayjs {
  let newComparisonMonth = currentComparisonMonth

  if (newFocusMonth.isSame(currentComparisonMonth, "month")) {
    newComparisonMonth = newFocusMonth.subtract(1, "month")
  }

  const now = dayjs()
  if (newComparisonMonth.isSame(now, "month")) {
    newComparisonMonth = newComparisonMonth.subtract(1, "month")
  }

  if (boxCreationDate && newComparisonMonth.isBefore(boxCreationDate, "month")) {
    newComparisonMonth = boxCreationDate.startOf("month")
  }

  return newComparisonMonth
}
